/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ShieldIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="shield"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 2.5A9.217 9.217 0 0 1 4 6" data-tinysvg-shape="arc" data-tinysvg-arc="4.747 -3.186 9.217 9.217 38.096 94.646 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 21.5A11.67 11.67 0 0 1 4 6" data-tinysvg-shape="arc" data-tinysvg-arc="14.891 10.193 11.67 11.67 104.343 201.058 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20 6A11.67 11.67 0 0 1 12 21.5" data-tinysvg-shape="arc" data-tinysvg-arc="9.109 10.193 11.67 11.67 338.942 435.657 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20 6A9.217 9.217 0 0 1 12 2.5" data-tinysvg-shape="arc" data-tinysvg-arc="19.253 -3.186 9.217 9.217 85.354 141.904 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
